import {ThemeContext} from "@/contexts/ThemeContext";
import {useContext} from "react";

/**
 * @typedef {import('@/contexts/ThemeContext').ThemeContextValue} ThemeContextValue
 */

/**
 * Hook to access white label theme configuration
 * @returns {Partial<ThemeContextValue>} Theme context value with theme, themeConfig, variant, and toggle functions
 */
export const useWhiteLabelTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    console.error("ThemeContext not found");
    return {};
  }

  if (!window.config.isWhiteLabelApp) {
    return {...context, themeConfig: {}};
  }

  return context;
};
